import React from 'react';

import { WsTypoColors, WsTypography, WsTypoVariants } from '../../../components/WsTypography';
import { FileInput, AttachmentIcon } from '../helper';
type FormAttachmentProps = {
  handleAttachments(event: React.ChangeEvent<HTMLInputElement>): void;
};
const FormAttachment = ({ handleAttachments }: FormAttachmentProps) => (
  <FileInput htmlFor="attachments">
    <input
      name="attachments"
      id="attachments"
      type="file"
      style={{ display: 'none' }}
      onChange={(event) => handleAttachments(event)}
    />
    <AttachmentIcon />
    <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY} cursor="pointer">
      Attach File
    </WsTypography>
  </FileInput>
);
export default FormAttachment;
